import classNames from "lib/classNames";
import { AnchorHTMLAttributes, PropsWithChildren, forwardRef } from "react";
import { TabThemeProps, tabTheme } from "hardcover-ui/theme/components/tab";
import ActiveLink from "components/ActiveLink";
import { usePage } from "@inertiajs/react";

type Props = {
  size?: TabThemeProps["size"];
  external?: boolean;
  variant?: TabThemeProps["variant"];
  greedy?: boolean | string;
  exact?: boolean;
  badge?: string | number;
  badgeClass?: string;
} & Partial<AnchorHTMLAttributes<HTMLAnchorElement>>;

const TabLink = forwardRef<HTMLAnchorElement, PropsWithChildren<Props>>(
  (
    {
      size = "lg",
      variant = "primary",
      badge = null,
      badgeClass = "",
      children,
      className,
      greedy = false,
      exact = false,
      ...rest
    },
    ref
  ) => {
    const { path } = usePage().props;

    const finalClassName = classNames(
      tabTheme.variant[variant],
      tabTheme.size[size],
      className
    );

    const selectedFinalClassName = classNames(
      tabTheme.variant[`${variant}Selected`],
      tabTheme.size[size],
      className
    );

    const props = {
      ref,
      className: finalClassName,
      ...rest,
    };

    return (
      <ActiveLink
        href={props.href}
        className={finalClassName}
        activeClassName={selectedFinalClassName}
        greedy={greedy}
        exact={exact}
        badge={badge ? Number(badge) : null}
        badgeClass={badgeClass}
        pathname={String(path)}
      >
        <>{children}</>
      </ActiveLink>
    );
  }
);

export default TabLink;
